import "./SectionSelector.scss";

/**
 * SectionSelector component
 * @param {{
 *   className?: string,
 *   currentSection: number,
 *   sectionList: {text: string, count?: number}[],
 *   onSectionChange: (next: number) => void
 * }} props
 * @returns {JSX.Element} SectionSelector
 */
function SectionSelector({ className, currentSection, sectionList, onSectionChange }) {
  return (
    <div className={`section-selector ${className}`}>
      <div className="selectors">
        {sectionList.map((s, k) => (
          <button
            key={k}
            className={`selector ${k === currentSection ? "active" : ""}`}
            onClick={() => onSectionChange(k)}
          >
            <span>{s.text}</span>
            {s.count && <i>{s.count}</i>}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SectionSelector;
